import React from "react";

export default function Completed({
  inspectionFilter,
  checkDueThisPeriod,
  startInspection,
  type,
  title,
  countOps,
  existsInDatabase,
}) {
  return (
    <ul className="list-unstyled" style={{ width: "100%" }}>
      {inspectionFilter("complete", type).map((inspection) => (
        <li key={title(inspection) + "_" + inspection.id}>
          <div
            title={title(inspection)}
            onClick={() =>
              checkDueThisPeriod(
                inspection.dueThisPeriod,
                inspection.dueDate,
                inspection.type
              ) &&
              existsInDatabase(inspection) &&
              startInspection(inspection)
            }
            className="btn btn-success btn-inspection"
            style={{
              float: "right",
              cursor: existsInDatabase(inspection) ? "pointer" : "text",
              whiteSpace: "normal",
              position: "relative",
              backgroundColor: existsInDatabase(inspection) ? null : "gray",
              border: existsInDatabase(inspection) ? "" : "1px solid gray",
            }}
          >
            {countOps > 1 && (
              <sup
                style={{
                  position: "absolute",
                  top: "9px",
                  left: "3px",
                }}
              >
                {inspection.operationShortName}
              </sup>
            )}
            <span>{inspection.title}</span>
            {inspection.oos &&
              (inspection.status !== 5 || inspection.done > 0) && (
                <span>
                  (<strong>OOS</strong>)
                </span>
              )}
            {!inspection.oos &&
              (inspection.status !== 5 || inspection.done > 0) && (
                <span>
                  (<span>{inspection.done}</span>/
                  <span>{inspection.count}</span>)
                </span>
              )}
            {inspection.status === 5 && +inspection.done === 0 && (
              <span>
                (<strong>NU</strong>)
              </span>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
}
